import { AxiosError, isAxiosError } from 'axios'

import { httpClient } from 'shared/lib'
import consoleMessage from 'shared/utils/helpers/consoleMessage'

import { BracketsType } from './types'

export function fetchProducts(productUuid: string): Promise<BracketsType> {
   let errMessage = ''

   return httpClient
      .get(`products/${productUuid}/replacements/brackets`)
      .then((res) => res.data)
      .catch((error: Error | AxiosError<ErrorType>) => {
         if (isAxiosError<ErrorType>(error)) {
            errMessage = error.response?.data?.errors[0].defaultMessage || ''
         } else {
            errMessage = error.message
         }
         consoleMessage('PRODUCTS_LIST fetchProducts service', errMessage, 'error')
         throw error
      })
}
